// base
import { createContext, useContext, useState } from 'react';

export interface DrawerContextProps {
  isDrawerOpen: boolean;
  setIsDrawerOpen: (value: boolean) => void;
}

export const DrawerContext = createContext<DrawerContextProps>({
  isDrawerOpen: false,
  setIsDrawerOpen: () => {}
});

interface Props {
  children: React.ReactNode;
}

export const DrawerProvider: React.FC<Props> = ({ children }) => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  return (
    <DrawerContext.Provider value={{ isDrawerOpen, setIsDrawerOpen }}>
      {children}
    </DrawerContext.Provider>
  );
};

export const useDrawer = () => {
  const context = useContext(DrawerContext);
  if (!context) {
    throw new Error('useDrawer must be used within an DrawerProvider');
  }

  return context;
};
